module.exports = __webpack_public_path__ + "img/icon-back-arrow.8ad8f2e6.svg";